export default __webpack_public_path__ + "static/media/mobile-errorh265.69b4fc87.mp4";